import { c as _c } from "react/compiler-runtime";
import type { FetchChatTranslateParams } from '@module/apis/client-side/chat/type';
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useFetchChatTranslateMutation } from '@module/queries/chat/chatQueryHooks';
import useSocketStore from '@module/stores/useSocketStore';
import type { NormalChatMessage } from '@module/types/centrifuge/public-message';
import { truncateNormalChatMessage } from '@module/utils/truncateText';
import { useCallback, useState } from 'react';
interface UseChatTranslateParams {
  chatData: NormalChatMessage;
  setTranslatedMessage: (message: string) => void;
  filtered?: boolean;
  filteredMessage?: string;
  onError: ((error: Error, variables: FetchChatTranslateParams, context: unknown) => Promise<unknown> | unknown) | undefined;
  isRoomMaster?: boolean;
  // 비로그인 상태에서 translate가 호출됐을 때(버튼 클릭 등). 자동 번역은 BJ라 항상 로그인 상태.
  onUnauthenticated?: () => void;
}
interface UseChatTranslateReturn {
  translate: () => void;
  isPending: boolean;
  isTranslated: boolean;
}

/**
 * 채팅 메시지 번역 실행 로직(가드 + 파라미터 조립 + mutation).
 * ChatTranslateButton(클릭)과 AutoChatTranslate(마운트 자동 실행)가 공유.
 */
const useChatTranslate = t0 => {
  const $ = _c(19);
  const {
    chatData,
    setTranslatedMessage,
    filtered,
    filteredMessage,
    onError,
    isRoomMaster,
    onUnauthenticated
  } = t0;
  const {
    isLogin
  } = useGetLoginInfoQuery();
  const token = useSocketStore(_temp);
  const [isTranslated, setIsTranslated] = useState(false);
  let t1;
  if ($[0] !== setTranslatedMessage) {
    t1 = data => {
      setTranslatedMessage(data.data.translatedMessage);
      setIsTranslated(true);
    };
    $[0] = setTranslatedMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onError || $[3] !== t1) {
    t2 = {
      onSuccess: t1,
      onError
    };
    $[2] = onError;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    mutate,
    isPending
  } = useFetchChatTranslateMutation(t2);
  let t3;
  if ($[5] !== chatData || $[6] !== filtered || $[7] !== filteredMessage || $[8] !== isLogin || $[9] !== isRoomMaster || $[10] !== mutate || $[11] !== onUnauthenticated || $[12] !== setTranslatedMessage || $[13] !== token) {
    t3 = () => {
      if (!token) {
        return;
      }
      if (!isLogin) {
        onUnauthenticated?.();
        return;
      }
      if (filtered) {
        setTranslatedMessage(filteredMessage || "");
        setIsTranslated(true);
        return;
      }
      mutate({
        message: truncateNormalChatMessage(chatData),
        src_lang: chatData.data.lang?.[0] || "ko",
        target_lang: SettingConfig.LANG,
        ...(isRoomMaster ? {
          offset: chatData.offset
        } : {}),
        token
      });
    };
    $[5] = chatData;
    $[6] = filtered;
    $[7] = filteredMessage;
    $[8] = isLogin;
    $[9] = isRoomMaster;
    $[10] = mutate;
    $[11] = onUnauthenticated;
    $[12] = setTranslatedMessage;
    $[13] = token;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const translate = t3;
  let t4;
  if ($[15] !== isPending || $[16] !== isTranslated || $[17] !== translate) {
    t4 = {
      translate,
      isPending,
      isTranslated
    };
    $[15] = isPending;
    $[16] = isTranslated;
    $[17] = translate;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};
export default useChatTranslate;
function _temp(state) {
  return state.token;
}